var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bl-loading-dialog-mv',{attrs:{"is-active":_vm.showLoader,"text-loading":"Tunggu sebentar ya..."},on:{"update:isActive":function($event){_vm.showLoader=$event},"update:is-active":function($event){_vm.showLoader=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }